/**
 * The little of a user a picker needs. Anything the search endpoint returns
 * satisfies it, so a caller holding whole `User` records can pass them
 * straight through.
 */
export interface UserOption {
  id: string;
  first_name: string;
  last_name: string;
  email: string | null;
}

/**
 * How a user reads in a list of people: the name, and the address that tells
 * two people of the same name apart. A missing last name leaves no gap.
 */
export function userOptionLabel(user: UserOption): string {
  const fullName = `${user.first_name}${user.last_name ? ` ${user.last_name}` : ''}`;
  return user.email ? `${fullName} (${user.email})` : fullName;
}
